<app-hvb-header></app-hvb-header>
<hr class="mb-0">
<div class="event-page">
  <div class="title">
    {{'eventPage.title' | translate}}
  </div>
  <div class="content">
    <div class="left-column">
      <div class="intro">
        {{'eventPage.leftColumn.intro.1' | translate}}<br><br>
        {{'eventPage.leftColumn.intro.2' | translate}}<br><br>
        {{'eventPage.leftColumn.intro.3' | translate}}
      </div>
      <ng-container *ngFor="let event of (events$|async)">
        <div class="white-box">
          <markdown [data]="event.attributes?.description"></markdown>
        </div>
      </ng-container>
    </div>
    <div class="white-box summary">
      <b>{{'eventPage.rightColumn.eventsHVB.title' | translate}}</b>
      <br><br>
      <ng-container *ngFor="let event of (events$|async)">
        <markdown [data]="event.attributes?.summary"></markdown>
        <br>
      </ng-container>
      <br><br>
      <b>{{'eventPage.rightColumn.eventsCommon.title' | translate}}</b>
      <br><br>
      {{'eventPage.rightColumn.eventsCommon.event1' | translate}}
    </div>
  </div>
</div>
<hvb-footer></hvb-footer>
